import React, { ReactElement } from 'react';
import { useLocation } from 'react-router';
import CheckAccess from '../check-access/check-access.component';
import FilteredLink from '../filtered-link/filtered-link.component';
import ListItem from '../list-item/list-item.component';
import ListItemText from '../list-item-text/list-item-text.component';
import ListItemIcon from '../list-item-icon/list-item-icon.component';
import FormatService from '../../services/format-service';
import useStylesNavigationContentItem from './navigation-content-item.styles';

const NavigationContentItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    menuItem,
    onClick,
  } = props;

  const { classes } = useStylesNavigationContentItem();
  const location: ReactRouterLocation = useLocation();

  const currentRoute: string = menuItem.route ? location.pathname : `${location.pathname}${location.search || ''}`;
  const menuRoute: string = menuItem.route || menuItem.link;
  const isActive: boolean = currentRoute === menuRoute;

  const activeClassName: string | undefined = isActive ? classes.navigationContentItemActive : undefined;
  const iconActiveClassName: string | undefined = isActive ? classes.navigationContentItemIconActive : undefined;

  return (
    <CheckAccess permissions={menuItem.permission ? [menuItem.permission] : null}>
      <FilteredLink
        isExternal={menuItem.isExternal}
        link={menuItem.link}
        onClick={onClick}
      >
        <ListItem
          isLight
          isButton
          isDefault
          className={FormatService.formatClassNames(classes.navigationContentItem, activeClassName)}
        >
          <ListItemIcon
            isLight
            className={FormatService.formatClassNames(classes.navigationContentItemIcon, iconActiveClassName)}
          >
            {menuItem.icon}
          </ListItemIcon>
          <ListItemText isHeader>
            {menuItem.name}
          </ListItemText>
        </ListItem>
      </FilteredLink>
    </CheckAccess>
  );
});

export default NavigationContentItem;
